import RunestoneEditor from "@/components/forge/RunestoneEditor";
import { useEffect, useState } from "react";

interface ForgeRunePageProps {
    rawSvgContent: string;
    runeName: string;
}

export default function ForgeRunePage({
    rawSvgContent,
    runeName,
}: ForgeRunePageProps) {
    const [svgContent, setSvgContent] = useState<string | null>(null);

    useEffect(() => {
        setSvgContent(rawSvgContent);
    }, [rawSvgContent]);

    if (!svgContent) {
        return <div>Loading...</div>;
    }

    return (
        <div className="flex h-full flex-col items-center justify-center">
            <RunestoneEditor svgContent={svgContent} runeName={runeName} />
        </div>
    );
}
